import * as React from 'react';
import { createHashRouter, RouterProvider, Navigate } from 'react-router-dom';
import GuardRoute from './components/guardRoute';
import { AuthContextProvider } from './context/auth';
import { ThemeContextProvider } from './context/theme';
import { GlobalsContextProvider } from './context/globals';
import { LoadingModalContextProvider } from './components/modal/loading';
import { AlertModalContextProvider } from './components/modal/alert';
import { SnackbarProvider } from 'notistack';

import Login from './pages/login';
import Dashboard from './pages/dashboard';
import ReestablecerClave from './pages/reestablecer-clave';
import RecuperarAcceso from './pages/recuperar-acceso';
import Usuario from './pages/usuario';
import EditarUsuario from './pages/usuario/editar';
import DeterminacionGrupo from './pages/determinacion-grupo';
import Codigo from './pages/codigo';
import Determinacion from './pages/determinacion';
import Nhpdgd from './pages/nhpdgd';

const router = createHashRouter([
	{ path: "/login", element: <GuardRoute type="public" path="/login" component={<Login />} /> },
	{ path: "/login/:token/:window", element: <GuardRoute type="public" path="/login/:token/:window" component={<Login />} /> },
	{ path: "/reestablecer-clave/:token", element: <GuardRoute type="public" path="/reestablecer-clave/:token" component={<ReestablecerClave />} /> },
	{ path: "/recuperar-acceso", element: <GuardRoute type="public" path="/recuperar-acceso" component={<RecuperarAcceso />} /> },
	{ path: "/dashboard", element: <GuardRoute type="private" path="/dashboard" component={<Dashboard />} /> },
	{ path: "/usuario/nuevo", element: <GuardRoute type="private" path="/usuario/nuevo" component={<EditarUsuario />} /> },
	{ path: "/usuario/editar", element: <GuardRoute type="private" path="/usuario/editar" component={<EditarUsuario />} /> },
	{ path: "/usuario", element: <GuardRoute type="private" path="/usuario" component={<Usuario />} /> },
	{ path: "/determinacion-grupo", element: <GuardRoute type="private" path="/determinacion-grupo" component={<DeterminacionGrupo />} /> },
	{ path: "/codigo", element: <GuardRoute type="private" path="/codigo" component={<Codigo />} /> },
	{ path: "/determinacion", element: <GuardRoute type="private" path="/determinacion" component={<Determinacion />} /> },
	{ path: "/nhpdgd", element: <GuardRoute type="private" path="/nhpdgd" component={<Nhpdgd />} /> },
	{ path: "/", element: <Navigate to="/login" replace /> },
]);

export default function AppRoot() {
	return (
		<AuthContextProvider>
			<GlobalsContextProvider>
				<ThemeContextProvider>
					<SnackbarProvider maxSnack={3} anchorOrigin={{ horizontal: "center", vertical: "bottom" }} autoHideDuration={6000}>
						<LoadingModalContextProvider>
							<AlertModalContextProvider>
								<InnerApp />
							</AlertModalContextProvider>
						</LoadingModalContextProvider>
					</SnackbarProvider>
				</ThemeContextProvider>
			</GlobalsContextProvider>
		</AuthContextProvider>
	);
}

function InnerApp() {
	React.useEffect(() => {
		const el = document.getElementById('initial-splash');
		const hide = () => {
			if (el?.parentNode) {
				try {
					el.parentNode.removeChild(el);
				} catch (_) {}
			}
		};
		// Opción 1: ocultar tras el primer paint de la app para evitar parpadeo
		requestAnimationFrame(() => requestAnimationFrame(hide));
	}, []);
	return <RouterProvider router={router} />;
}
